import { useEffect } from 'react';
import {
  expireScanSessionIfStale,
  msUntilNextLocalMidnight,
} from '../utils/scanSessionCache';

/**
 * Each open app tab expires scanning sessionStorage at local midnight.
 * Visibility/focus catch-up covers devices that slept through the timer.
 */
export function useDailyScanSessionReset(): void {
  useEffect(() => {
    expireScanSessionIfStale();

    let cancelled = false;
    const catchUp = (): void => {
      if (!cancelled) {
        expireScanSessionIfStale();
      }
    };

    let timeoutId: number | undefined;

    const scheduleMidnight = (): void => {
      timeoutId = window.setTimeout(() => {
        if (cancelled) {
          return;
        }
        catchUp();
        scheduleMidnight();
      }, msUntilNextLocalMidnight());
    };

    scheduleMidnight();
    document.addEventListener('visibilitychange', catchUp);
    window.addEventListener('focus', catchUp);

    return () => {
      cancelled = true;
      if (timeoutId != null) {
        window.clearTimeout(timeoutId);
      }
      document.removeEventListener('visibilitychange', catchUp);
      window.removeEventListener('focus', catchUp);
    };
  }, []);
}
